const TRAILING_PUNCTUATION = /[),.;!?]+$/;

export const parseAgentUrls = (text = '') => {
	const values = [];
	const seen = new Set();
	for (const match of String(text).matchAll(/https?:\/\/[^\s<>"']+/gi)) {
		const token = match[0].replace(TRAILING_PUNCTUATION, '');
		try {
			const url = new URL(token).toString();
			if (seen.has(url)) continue;
			seen.add(url);
			values.push({ url, position: match.index, token });
		} catch {
			// Invalid URL-like text remains ordinary composer text.
		}
	}
	return values;
};
